var pageStyles = {
  "Page": "pb-Page__Page",
  "wrapper": "pb-Page__wrapper",
  "main": "pb-Page__main"
};
export default pageStyles;